import { 
    getLandlordReport,
    } from "@/apis/company/landlordReport.js"; 
/* 
  這邊可以改為用 types 物件取代 matutions_type.js (繼續用也可以)
  然後在前面加上模組名稱作為前綴，用來避免與其他模組重複。
  因為 action、mutation、和 getter 依然是註冊在全域的命名空間
*/
const types = {
    set_landlord_report_list: 'landlordReport/set_landlord_report_list',
    set_filter_word: 'landlordReport/set_filter_word',
    set_filter_default: 'landlordReport/set_filter_default',
    set_filter_result: 'landlordReport/set_filter_result',
    set_loading: 'landlordReport/set_loading'

}

// count state 必須是 Object
const state = {
    landlordReportList: [],
    filterWord: '',
    filterResult: [],
    isDefault: false,
    isLoading: false
}

// getters 也可以整理到這邊直接返回 count 內容
const getters = {
    GET_BIZ_LANDLORD_REPORT_LIST: (state) => {
        return state.landlordReportList
    },
    GET_BIZ_LANDLORD_REPORT_FILTER_WORD: (state) => {
        return state.filterWord
    },
    GET_BIZ_LANDLORD_REPORT_FILTER_DEFAULT: (state) => {
        return state.isDefault
    },
    GET_BIZ_LANDLORD_REPORT_TOTAL: (state) => {
        const list = state.filterResult
        let data = {
            income: 0,
            incomeCount: 0,
            expense: 0,
            expenseCount: 0,
            payable: 0,
            payableCount: 0
        } 
        for (let i = 0; i < list.length; i++) {
            const element = list[i];
            data.income += element.amountVO.totalIncomeAmount
            data.incomeCount += element.amountVO.totalIncomeAmount?1:0
            data.expense += element.amountVO.totalExpenseAmount
            data.expenseCount += element.amountVO.totalExpenseAmount?1:0
            data.payable += element.amountVO.payableAmount,
            data.payableCount += element.amountVO.payableAmount?1:0
        }
        return data
    },
}

// actions 也是以 Object 形式建構。
const actions = {
    getBizLandlordReportList ( {commit, state} ) {
        return new Promise((resolve, reject) => {
            getLandlordReport()
            .then(res => {
                console.log('getLandlordReport',res)
                if( res.data.status == "SUCCESS" ){
                    commit(types.set_landlord_report_list, res.data.result);
                    resolve()
                }
            })
            .catch(err => {
                reject(err)
            })
            
        })
    },
    setBizLandlordReportFilterWord ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_word, value);
            resolve()
        })
    },
    setBizLandlordReportFilterDefault ( {commit} ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_default);
            resolve()
        })
    },
    setBizLandlordReportFilterResult ( {commit} , value ) {
        return new Promise((resolve, reject) => {
            commit(types.set_filter_result, value);
            resolve()
        })
    },
}

// mutations
const mutations = {
    [types.set_landlord_report_list](state, data){
        state.landlordReportList = data
    },
    [types.set_filter_word](state, data){
        state.filterWord = data
        state.isDefault = false
    },
    [types.set_filter_default](state, data){
        // state.filterQuery = data
        state.filterWord = ''
        setTimeout(()=>{
            state.isDefault = true
        },100)
    },
    [types.set_filter_result](state, data){
        state.filterResult = data
    },
   
}

/*
因為我們把 vuex 所有職權都寫在同一隻檔案，
所以必須要 export 出去給最外層 index.js 組合使用
*/
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/bussiness/financialReport/landlordReport.js